import { z } from "zod";

export const EmailLoginViewModelSchema = z.object({
  emailOrUsername: z.string().min(1, "Email or username is required"),
  returnUrl: z.string().optional(),
});

export type EmailLoginViewModel = z.infer<typeof EmailLoginViewModelSchema>;

export interface EmailLoginResponse {
  emailSent: boolean;
  userFound: boolean;
  emailAddress?: string;
}